import { useState, useRef, useCallback } from 'react';
import { apiHolder, apis } from 'api';
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
export function useSharedAccountsUnread() {
    const [unreadMap, setUnreadMap] = useState({});
    const [loading, setLoading] = useState(false);
    const requestIdRef = useRef(0);
    const fetchUnread = useCallback(() => {
        const currentRequestId = ++requestIdRef.current;
        setLoading(true);
        mailApi
            .getSharedAccountsUnread()
            .then(map => {
            if (currentRequestId === requestIdRef.current) {
                setUnreadMap(map);
                setLoading(false);
            }
        })
            .catch(() => {
            if (currentRequestId === requestIdRef.current) {
                setLoading(false);
            }
        });
    }, []);
    return { unreadMap, loading, fetchUnread };
}
